import React from 'react';
import { Container, Button } from 'react-bootstrap';
import icons from './Icons';
import './legal.css';

const NotFound = ({ onNavigate }) => {
  const handleNavClick = (pageId) => {
    if (onNavigate) {
      onNavigate(pageId);
    } else {
      window.location.hash = pageId;
    }
  };

  return (
    <div className="notfound-page-wrapper py-5 d-flex align-items-center min-vh-75">
      <Container className="px-3 px-lg-5">
        <div className="text-center mx-auto" style={{ maxWidth: '640px' }}>
          <div className="mb-3">
            <span className="legal-badge">
              <span className="legal-meta-dot dot-orange" />
              ERROR 404
            </span>
          </div>

          <div
            className="fw-bold font-monospace mb-2"
            style={{
              fontSize: 'clamp(4.5rem, 12vw, 7.5rem)',
              lineHeight: 1,
              background: 'linear-gradient(135deg, var(--brand-orange) 0%, var(--brand-blue) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.04em'
            }}
          >
            404
          </div>

          <h1 className="legal-title mb-3 fs-2">Page Not Found</h1>
          <p className="legal-subtitle mb-4">
            The page you are looking for doesn't exist, has been moved, or an unexpected error occurred. Let's guide you back to the growth ecosystem.
          </p>

          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
            <Button
              variant="light"
              className="btn-start-project px-4 py-2.5 d-inline-flex align-items-center justify-content-center gap-2"
              onClick={() => handleNavClick('home')}
            >
              <span>Return Home</span>
              {icons.arrowRight}
            </Button>
            <Button
              variant="outline-secondary"
              className="px-4 py-2.5 rounded-3 fw-semibold text-body border-1"
              style={{ background: 'var(--bg-card)', borderColor: 'var(--border-subtle)' }}
              onClick={() => handleNavClick('services')}
            >
              View Services
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotFound;
